export type WarehouseLabelDisplay = {
  qr: boolean;
  title: boolean;
  subtitle: boolean;
};

export const defaultWarehouseLabelDisplay: WarehouseLabelDisplay = {
  qr: true,
  title: true,
  subtitle: true
};
